export class AudioIcon {
  public audioIconUnmuted: SVGElement;
  public audioIconMuted: SVGElement;

  constructor() {
    this.audioIconUnmuted = this.createAudioIconUnmuted();
    this.audioIconMuted = this.createAudioIconMuted();
  }

  private createAudioIconUnmuted(): SVGElement {
    const audioIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    audioIcon.setAttributeNS(null, "id", "audioIconUnmuted");
    audioIcon.setAttributeNS(null, "x", "31px");
    audioIcon.setAttributeNS(null, "y", "28px");
    audioIcon.setAttributeNS(null, "viewBox", "0 0 31 28");

    const svgGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgGroup?.classList?.add("svgIcon");
    audioIcon.appendChild(svgGroup);

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttributeNS(
      null,
      "d",
      "M21.0008,0.0720318C20.556,-0.117811,20.0379,0.0805569,19.8435,0.514827C19.6492,0.949098,19.8522,1.45512,20.297,1.6449C25.1233,3.70434,28.242,8.35761,28.2422,13.4998C28.2422,18.6423,25.1234,23.2957,20.2966,25.3551C19.8518,25.5448,19.6488,26.0508,19.8431,26.4852C19.9874,26.8077,20.3102,27,20.649,27C20.7664,27,20.8859,26.9769,21.0004,26.928C26.4674,24.5954,30,19.3246,30,13.4997C29.9998,7.67531,26.4674,2.40462,21.0008,0.0720318Z"
    );

    const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path2.setAttributeNS(
      null,
      "d",
      "M21.2351,6.69434C20.8735,6.37822,20.3179,6.4082,19.9941,6.76134C19.6703,7.11454,19.701,7.65706,20.0627,7.97324C21.6712,9.37932,22.5937,11.3937,22.5937,13.5C22.5937,15.6062,21.6711,17.6206,20.0627,19.0267C19.701,19.3428,19.6703,19.8854,19.9941,20.2386C20.1677,20.4279,20.4079,20.5244,20.6492,20.5244C20.8579,20.5244,21.0674,20.4522,21.2351,20.3056C23.2157,18.5744,24.3515,16.0937,24.3515,13.4999C24.3515,10.9061,23.2156,8.42553,21.2351,6.69434Z"
    );

    const path3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path3.setAttributeNS(
      null,
      "d",
      "M15.3973,2.16277C15.1018,2.01658,14.7473,2.04502,14.4803,2.23623L7.65176,7.12598H0.878906C0.393516,7.12598,0,7.51024,0,7.98422V19.0155C0,19.4895,0.393516,19.8738,0.878906,19.8738H7.6517L14.4802,24.7637C14.6339,24.8737,14.8164,24.9298,15.0001,24.9298C15.1356,24.9298,15.2718,24.8992,15.3973,24.8371C15.6927,24.6909,15.8789,24.395,15.8789,24.0716V2.9282C15.8789,2.60482,15.6927,2.30884,15.3973,2.16277ZM14.121,22.3778L8.45918,18.3234C8.30842,18.2154,8.12637,18.1572,7.93939,18.1572H1.75781V8.84246H7.93939C8.12631,8.84246,8.30842,8.78422,8.45912,8.67636L14.121,4.62197V22.3778Z"
    );

    svgGroup.appendChild(path1);
    svgGroup.appendChild(path2);
    svgGroup.appendChild(path3);

    return audioIcon;
  }

  private createAudioIconMuted(): SVGElement {
    const audioIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    audioIcon.setAttributeNS(null, "id", "audioIconMuted");
    audioIcon.setAttributeNS(null, "x", "31px");
    audioIcon.setAttributeNS(null, "y", "28px");
    audioIcon.setAttributeNS(null, "viewBox", "0 -1 31 28");

    const svgGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgGroup.classList?.add("svgIcon");
    audioIcon.appendChild(svgGroup);

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttributeNS(
      null,
      "d",
      "M16.3501,0.829286C16.046,0.678799,15.6811,0.708072,15.4062,0.904912L8.37681,5.93848H1.40476C0.90509,5.93848,0.5,6.33404,0.5,6.82196V18.1777C0.5,18.6657,0.90509,19.0612,1.40476,19.0612H8.37675L15.4061,24.0949C15.5643,24.2082,15.7522,24.2659,15.9412,24.2659C16.0808,24.2659,16.221,24.2344,16.3501,24.1705C16.6542,24.02,16.8459,23.7154,16.8459,23.3825V1.61724C16.8459,1.28434,16.6542,0.979655,16.3501,0.829286ZM15.0364,21.6389L9.20798,17.4652C9.05278,17.3541,8.86538,17.2942,8.6729,17.2942H2.30951V7.70544H8.6729C8.86532,7.70544,9.05278,7.64548,9.20792,7.53446L15.0364,3.36082V21.6389Z"
    );

    const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path2.setAttributeNS(
      null,
      "d",
      "M25.2799,11.7634L21.8442,8.32748C21.6206,8.10399,21.6206,7.74264,21.8442,7.51915C22.0676,7.29566,22.429,7.29566,22.6525,7.51915L26.0883,10.955L29.524,7.51915C29.7476,7.29566,30.1088,7.29566,30.3323,7.51915C30.5559,7.74264,30.5559,8.10399,30.3323,8.32748L26.8966,11.7634L30.3323,15.1992C30.5559,15.4227,30.5559,15.7841,30.3323,16.0076C30.2209,16.1191,30.0745,16.1751,29.9281,16.1751C29.7818,16.1751,29.6355,16.1191,29.524,16.0076L26.0883,12.5717L22.6525,16.0076C22.541,16.1191,22.3947,16.1751,22.2483,16.1751C22.102,16.1751,21.9556,16.1191,21.8442,16.0076C21.6206,15.7841,21.6206,15.4227,21.8442,15.1992L25.2799,11.7634Z"
    );

    svgGroup.appendChild(path1);
    svgGroup.appendChild(path2);

    return audioIcon;
  }
}
